import { Field } from 'SharedDir/declarations/fields';
import { computed } from 'vue';
import {
  FIELD_TYPE_ADDRESS,
  FIELD_TYPE_CHECKBOX,
  FIELD_TYPE_DYNAMIC_TABLE,
  FIELD_TYPE_FILE,
  FIELD_TYPE_FILE_SET,
  FIELD_TYPE_FIXED_TABLE,
  FIELD_TYPE_GEOLOCATION,
  FIELD_TYPE_INPUT_DATE,
  FIELD_TYPE_INPUT_NUMBER,
  FIELD_TYPE_INPUT_TEXT,
  FIELD_TYPE_LABEL,
  FIELD_TYPE_OBJECT,
  FIELD_TYPE_PICTURE,
  FIELD_TYPE_PICTURE_GALLERY,
  FIELD_TYPE_SAMPLE_FILE,
  FIELD_TYPE_SELECT,
  FIELD_TYPE_SEPARATOR,
  FIELD_TYPE_TEXTAREA,
  FIELD_TYPE_TREE,
  FIELD_TYPE_TREE_SELECT,
  FIELD_TYPE_VIDEO,
  FIELD_TYPE_WYSIWYG,
} from 'SharedDir/constants/field-types';
import { WithRelations } from 'SharedDir/declarations/shared';
import { DefinedProps } from 'SharedDir/declarations/vue';

export default <E = object>(props: DefinedProps<{ field: WithRelations<Field> } & E>) => {
  const itIsTextField = computed(() => props.field.fieldTypeId === FIELD_TYPE_INPUT_TEXT.id);
  const itIsTextareaField = computed(() => props.field.fieldTypeId === FIELD_TYPE_TEXTAREA.id);
  const itIsNumberField = computed(() => props.field.fieldTypeId === FIELD_TYPE_INPUT_NUMBER.id);
  const itIsDateField = computed(() => props.field.fieldTypeId === FIELD_TYPE_INPUT_DATE.id);
  const itIsCheckboxField = computed(() => props.field.fieldTypeId === FIELD_TYPE_CHECKBOX.id);
  const itIsSelectField = computed(() => props.field.fieldTypeId === FIELD_TYPE_SELECT.id);
  const itIsFileField = computed(() => props.field.fieldTypeId === FIELD_TYPE_FILE.id);
  const itIsFileSetField = computed(() => props.field.fieldTypeId === FIELD_TYPE_FILE_SET.id);
  const itIsAddressField = computed(() => props.field.fieldTypeId === FIELD_TYPE_ADDRESS.id);
  const itIsLabelField = computed(() => props.field.fieldTypeId === FIELD_TYPE_LABEL.id);
  const itIsFixedTableField = computed(() => props.field.fieldTypeId === FIELD_TYPE_FIXED_TABLE.id);
  const itIsDynamicTableField = computed(
    () => props.field.fieldTypeId === FIELD_TYPE_DYNAMIC_TABLE.id
  );
  const itIsWysiwygField = computed(() => props.field.fieldTypeId === FIELD_TYPE_WYSIWYG.id);
  const itIsPictureField = computed(() => props.field.fieldTypeId === FIELD_TYPE_PICTURE.id);
  const itIsPictureGalleryField = computed(
    () => props.field.fieldTypeId === FIELD_TYPE_PICTURE_GALLERY.id
  );
  const itIsVideoField = computed(() => props.field.fieldTypeId === FIELD_TYPE_VIDEO.id);
  const itIsGeolocationField = computed(
    () => props.field.fieldTypeId === FIELD_TYPE_GEOLOCATION.id
  );
  const itIsTreeSelectField = computed(() => props.field.fieldTypeId === FIELD_TYPE_TREE_SELECT.id);
  const itIsTreeField = computed(() => props.field.fieldTypeId === FIELD_TYPE_TREE.id);
  const itIsFileSampleField = computed(() => props.field.fieldTypeId === FIELD_TYPE_SAMPLE_FILE.id);
  const itIsSeparatorField = computed(() => props.field.fieldTypeId === FIELD_TYPE_SEPARATOR.id);
  const itIsObjectField = computed(() => props.field.fieldTypeId === FIELD_TYPE_OBJECT.id);
  return {
    itIsTextField,
    itIsTextareaField,
    itIsNumberField,
    itIsDateField,
    itIsCheckboxField,
    itIsSelectField,
    itIsFileField,
    itIsFileSetField,
    itIsAddressField,
    itIsLabelField,
    itIsFixedTableField,
    itIsDynamicTableField,
    itIsWysiwygField,
    itIsPictureField,
    itIsPictureGalleryField,
    itIsVideoField,
    itIsGeolocationField,
    itIsTreeSelectField,
    itIsTreeField,
    itIsFileSampleField,
    itIsSeparatorField,
    itIsObjectField,
  };
};
